<style scoped>
.sale-catg-group-header {
    background: rgba(255, 242, 204, 1);
    @apply pl-2;
    @apply border border-primary;
}

.qty-error {
    @apply bg-red text-white text-center font-black;
    @apply px-2 py-2 w-full relative z-0;
    @apply flex items-center justify-center;
    margin-top: -1px;
    border: solid theme('colors.indigo');
    border-width: 0px 1px 2px 1px;
}

.summary-info-table tr td:nth-child(2) {
    max-width: calc(100vw - 8rem);
}

.merchant-deliver-label {
    background-color: #fff2cc;
    border-width: 1px;
    border-color: #ffbf00;
    @apply px-3;
}
.promotion-label {
    background-color: #fff2cc;
    border-width: 1px;
    border-color: #ffbf00;
    @apply px-3 text-xs;
}

@media (max-width: theme('screens.md')) {
    .promotion-label {
        display: flex;
        flex-direction: column;
        width: 170px;
    }
    .merchant-deliver-label {
        display: flex;
        width: 90px;
    }
}
</style>
<template>
    <div>
        <table class="block w-full">
            <thead class="hidden md:block leading-tight">
                <tr class="flex w-full">
                    <th
                        class="block flex-1 px-4 py-2 font-bold min-w-40"
                        :class="[headerBg, headerBorder, 'border-r-0']"
                    >
                        {{ $t('cart.product.name') }}
                    </th>
                    <th
                        class="block w-1/6 px-4 py-2 font-bold"
                        :class="[headerBg, headerBorder, 'border-r-0']"
                    >
                        {{ $t('cart.product') }}
                    </th>
                    <th
                        class="block w-1/6 px-4 py-2 font-bold"
                        :class="[headerBg, headerBorder, 'border-r-0']"
                    >
                        {{ $t('product.price') }}
                    </th>
                    <th
                        class="block w-1/6 px-4 py-2 font-bold"
                        :class="[headerBg, headerBorder, 'border-r-0']"
                    >
                        {{ $t('product.qty') }}
                    </th>
                    <th
                        class="block w-1/6 px-4 py-2 font-bold"
                        :class="[headerBg, headerBorder]"
                    >
                        {{ $t('cart.total') }}
                    </th>
                </tr>
            </thead>
            <tbody class="block w-full scrollbar-theme">
                <template v-for="(g, gi) in productsGroupList">
                    <tr
                        v-if="g.saleCatgSlctDesp"
                        :key="`group_${gi}`"
                        class="flex items-center sale-catg-group-header"
                        :class="[rowBorder]"
                    >
                        <div class="text-lg font-medium">
                            <b>{{ g.saleCatgSlctDesp }}</b>
                            共消費
                        </div>
                        <div class="self-center ml-2">
                            {{
                                totalPriceBySaleCatgKey(g.saleCatgSlctKey)
                                    | price(true)
                            }}
                        </div>
                        <div
                            v-if="$scopedSlots.groupHeaderRightArea"
                            class="sale-catg-group-header-right-area ml-auto mr-2"
                        >
                            <slot
                                name="groupHeaderRightArea"
                                :saleCatgSlctCode="g.saleCatgSlctCode"
                                :saleCatgSlctDesp="g.saleCatgSlctDesp"
                            >
                            </slot>
                        </div>
                    </tr>
                    <template v-for="(p, pi) in g.products">
                        <tr
                            :key="`group_${gi}_product_${pi}`"
                            class="block clearfix m-1 md:flex md:flex-row md:m-0 md:py-8"
                            :class="[rowBorder]"
                        >
                            <td
                                class="hidden md:flex md:flex-col justify-center md:items-center md:w-auto md:flex-1"
                            >
                                <div
                                    class="merchant-deliver-label"
                                    v-if="isMerchantDeliver(p)"
                                >
                                    商戶直送
                                </div>
                                <contentNewLine
                                    v-if="$config.showProdName"
                                    class="py-1 text-center md:max-w-full md:px-4"
                                    :value="productDisplayFullname(p)"
                                />
                                <div
                                    class="promotion-label"
                                    v-if="
                                        crdtPntDisabled(p) ||
                                            (hasActivePrmtEvnt &&
                                                prmtEvntDisabled(p))
                                    "
                                >
                                    <div>
                                        以下推廣不適用於本產品：
                                    </div>
                                    <div v-if="crdtPntDisabled(p)">
                                        - 使用或獲得T-Coins回贈
                                    </div>
                                    <div
                                        v-if="
                                            hasActivePrmtEvnt &&
                                                prmtEvntDisabled(p)
                                        "
                                    >
                                        - 參與幸運大抽獎
                                    </div>
                                </div>
                            </td>

                            <td
                                class="flex flex-col items-center justify-center p-2 pb-0 float-left w-4/12 md:w-1/6 md:float-none md:p-2 "
                            >
                                <div class="w-full max-w-xs md:px-1">
                                    <router-link
                                        :to="{
                                            name: 'productInfo',
                                            params: {
                                                prodId: p.prodId
                                            }
                                        }"
                                    >
                                        <productImage
                                            :product="p"
                                            imageType="small"
                                        />
                                    </router-link>
                                </div>
                            </td>
                            <div
                                class="merchant-deliver-label md:hidden"
                                v-if="isMerchantDeliver(p)"
                            >
                                商戶直送
                            </div>
                            <div
                                class="promotion-label md:hidden"
                                v-if="
                                    crdtPntDisabled(p) ||
                                        (hasActivePrmtEvnt &&
                                            prmtEvntDisabled(p))
                                "
                            >
                                <div>
                                    以下推廣不適用於本產品：
                                </div>
                                <div v-if="crdtPntDisabled(p)">
                                    - 使用或獲得T-Coins回贈
                                </div>
                                <div
                                    v-if="
                                        hasActivePrmtEvnt && prmtEvntDisabled(p)
                                    "
                                >
                                    - 參與幸運大抽獎
                                </div>
                            </div>
                            <contentNewLine
                                v-if="$config.showProdName"
                                class="flex  py-2 pr-2 md:hidden"
                                :value="productDisplayFullname(p)"
                            />

                            <div
                                class="flex flex-row items-start w-8/12 ml-auto md:justify-between md:w-3/6 m-0 md:flex-row md:self-stretch md:items-stretch"
                            >
                                <div
                                    class="flex flex-wrap flex-row justify-center items-center md:justify-between w-9/12 md:w-2/3 md:flex-row"
                                >
                                    <td
                                        class="flex flex-col justify-center w-12 clearfix float-left md:float-none md:text-center md:w-1/2 md:p-2"
                                    >
                                        {{ p.prodUnitPrcAmt | price(true) }}
                                    </td>

                                    <td
                                        class="flex flex-col justify-center items-center text-center md:w-1/2 md:mx-auto md:relative"
                                    >
                                        <div v-if="readonly">
                                            <span class="md:hidden">
                                                {{ $t('product.qty') }}
                                            </span>
                                            {{ p.prodOrdQty }}
                                        </div>
                                        <quantityInput
                                            v-if="!readonly"
                                            v-model="p.prodOrdQty"
                                            @input="
                                                prodOrdQtyChanged(p, $event)
                                            "
                                            :max="maxQuantity(p)"
                                            class="md:mx-auto"
                                        />
                                        <div
                                            class="text-red text-xs mt-1 hidden md:block md:absolute lg:text-sm lg:font-semibold"
                                            style="top: 100%"
                                            v-if="!readonly && qtyErrMsg(p)"
                                        >
                                            {{ qtyErrMsg(p) }}
                                        </div>
                                        <!-- <div
                                        class="text-red mt-1 hidden md:block"
                                        v-if="!readonly && p.maxCustOrdQty"
                                    >
                                        (
                                        {{
                                            $t(
                                                'product.max.qty',
                                                p.maxCustOrdQty * maxOrdMltpQty
                                            )
                                        }}
                                        )
                                    </div> -->
                                    </td>
                                    <div
                                        class="text-red font-semibold mt-1 w-full text-center md:hidden"
                                        v-if="!readonly && qtyErrMsg(p)"
                                    >
                                        {{ qtyErrMsg(p) }}
                                    </div>
                                    <!-- <div
                                    class="text-red mt-1 w-full text-center md:hidden"
                                    v-if="!readonly && p.maxCustOrdQty"
                                >
                                    (
                                    {{
                                        $t(
                                            'product.max.qty',
                                            p.maxCustOrdQty * maxOrdMltpQty
                                        )
                                    }}
                                    )
                                </div> -->
                                </div>

                                <div
                                    class="flex flex-row items-start md:flex md:justify-between w-3/12 md:w-1/3 md:flex-row md:self-center"
                                >
                                    <td
                                        class="clearfix flex flex-col justify-center text-center w-full md:relative md:items-center"
                                    >
                                        <div class="md:block">
                                            <span class="md:hidden">
                                                {{ $t('cart.total') }}
                                            </span>
                                            {{
                                                (p.prodUnitPrcAmt *
                                                    p.prodOrdQty)
                                                    | price(true)
                                            }}
                                        </div>
                                        <button
                                            v-if="!readonly"
                                            class="btn border-0 underline p-0 text-red py-1 justify-center mt-2 md:absolute md:mt-0"
                                            style="top: 100%"
                                            @click="$emit('deleteProduct', p)"
                                        >
                                            {{ $t('cart.remove') }}
                                        </button>
                                    </td>
                                </div>
                            </div>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
        <div class="mt-2 flex" v-if="$slots.remark">
            <slot name="remark"></slot>
        </div>
        <div class="flex flex-col flex-wrap md:flex-row p-2 mt-4">
            <div v-if="$scopedSlots.leftInfo">
                <slot name="leftInfo"></slot>
            </div>
            <div class="ml-auto" v-if="showSummary">
                <productTableSummaryInfo
                    :list="list"
                    :dsctAmt="dsctAmt"
                    :additionalInfoList="rightInfoList"
                    :showCrdtPntEarnAmt="showCrdtPntEarnAmt"
                    :crdtPntEarnAmt="crdtPntEarnAmt"
                    class="summary-info-table text-base"
                >
                    <!-- <template v-for="slot in $slots">
                        <template :slot="slot">
                            <slot :name="slot"></slot>
                        </template>
                    </template> -->
                    <template v-for="(_, slot) in $slots">
                        <template :slot="slot">
                            <slot :name="slot"></slot>
                        </template>
                    </template>
                </productTableSummaryInfo>
            </div>
        </div>
    </div>
</template>

<script>
import quantityInput from '@/components/quantityInput.vue';
import price from '@/components/priceFilter';
import productImage from '@/components/productImage.vue';
import contentNewLine from '@/components/contentNewLine';
import productTableSummaryInfo from './productTableSummaryInfo.vue';

export default {
    components: {
        quantityInput,
        productImage,
        contentNewLine,
        productTableSummaryInfo
    },
    filters: { price },
    props: {
        list: { type: Array, default: () => [] },
        groupByCategory: { type: Boolean, default: false },
        dsctAmt: { type: Number, default: 0 },
        crdtPntEarnAmt: { type: Number, default: 0 },
        readonly: { type: Boolean, default: false },
        showCrdtPntEarnAmt: { type: Boolean, default: true },
        headerBg: { default: 'bg-transparent' },
        headerBorder: { default: 'border-b border-primary' },
        rowBorder: { default: 'border-b border-primary' },
        rightInfoList: { type: Array, default: () => [] },
        leftInfoList: { type: Array, default: () => [] },
        showSummary: { type: Boolean, default: true },
        maxQty: { type: Function }
    },
    methods: {
        prodOrdQtyChanged(product, quantity) {
            this.$emit('prodOrdQtyChanged', product, quantity);
        },
        _maxQty(product) {
            const maxOrdQty = this.$store.getters.getProductMaxOrdQtyPerPerson(
                product
            );
            const {
                totalBoughtQty,
                rmnProdQty,
                stckAvailQty,
                pgsProdSaleQtyInd,
                prodUnitPrcAmt,
                maxProdSaleQty,
                chkProdInvtryInd
            } = product;
            let maxQty = rmnProdQty;
            if (maxProdSaleQty === undefined || maxProdSaleQty === null) {
                maxQty = Math.max(stckAvailQty, 0);
            }
            if (chkProdInvtryInd === 'N') {
                maxQty =
                    maxProdSaleQty === undefined || maxProdSaleQty === null
                        ? 9999
                        : rmnProdQty;
            } else {
                maxQty = Math.max(Math.min(maxQty, stckAvailQty), 0);
            }
            if (maxOrdQty) {
                maxQty = Math.max(
                    Math.min(maxOrdQty - totalBoughtQty, maxQty),
                    0
                );
            }
            if (pgsProdSaleQtyInd === 'Y') {
                maxQty = Math.min(
                    this.$store.getters.productActualRemainingQty(product),
                    maxQty
                );
            }
            if (prodUnitPrcAmt === undefined || prodUnitPrcAmt === null) {
                maxQty = 0;
            }

            return maxQty;
        }
    },
    computed: {
        maxQuantity() {
            return this.maxQty || this._maxQty;
        },
        maxOrdMltpQty() {
            return this.$store.getters.maxOrdMltpQty;
        },
        productActualRemainingQty() {
            return product =>
                this.$store.getters.productActualRemainingQty(product);
        },
        productDisplayFullname() {
            return product =>
                this.$store.getters.productDisplayFullname(product);
        },
        qtyErrMsg() {
            return product => {
                const { prodOrdQty, totalBoughtQty } = product;
                const maxOrdQty = this.$store.getters.getProductMaxOrdQtyPerPerson(
                    product
                );
                if (
                    product.prodUnitPrcAmt === undefined ||
                    product.prodUnitPrcAmt === null
                ) {
                    return this.$t('cart.error.unitPrc.null');
                }
                if (maxOrdQty) {
                    if (totalBoughtQty >= maxOrdQty) {
                        return this.$t(
                            'cart.error.excess.qty.per.cust.bought.all'
                        );
                    } else if (totalBoughtQty + prodOrdQty > maxOrdQty) {
                        return this.$t(
                            'cart.error.excess.qty.per.cust.bought.some',
                            totalBoughtQty,
                            maxOrdQty - totalBoughtQty
                        );
                    }
                }
                let actualRemainingQty = this.productActualRemainingQty(
                    product
                );
                if (prodOrdQty > actualRemainingQty) {
                    if (actualRemainingQty <= 0) {
                        return this.$t('cart.error.empty.stock');
                    }
                    return this.$t(
                        'cart.error.excess.rmn.qty',
                        actualRemainingQty
                    );
                }
                return undefined;
            };
        },
        totalQty() {
            return this.$store.getters.totalQty(this.list);
        },
        totalPrice() {
            return this.$store.getters.totalPrice(this.list);
        },
        totalPriceBySaleCatgKey() {
            return saleCatgSlctKey =>
                this.$store.getters.totalPrice(
                    this.list.filter(p => p.saleCatgSlctKey === saleCatgSlctKey)
                );
        },
        productsGroupList() {
            if (!this.groupByCategory) {
                return [
                    {
                        saleCatgSlctKey: undefined,
                        saleCatgSlctCode: undefined,
                        saleCatgSlctDesp: undefined,
                        products: this.list
                    }
                ];
            } else {
                let saleCatgList = this.$store.getters.getSaleCatgList(
                    this.list
                );
                if (this.list.some(p => !p.saleCatgSlctKey)) {
                    saleCatgList.push({
                        saleCatgSlctKey: undefined,
                        saleCatgSlctCode: 'OTHER',
                        saleCatgSlctDesp: '其他',
                        saleCatgSlctDispSeqNum:
                            Math.max(
                                ...saleCatgList.map(
                                    i => i.saleCatgSlctDispSeqNum
                                )
                            ) + 1
                    });
                }
                return saleCatgList.map(c => ({
                    ...c,
                    products: this.list.filter(
                        p => p.saleCatgSlctKey === c.saleCatgSlctKey
                    )
                }));
            }
        },
        isMerchantDeliver() {
            return product => {
                return product.prodSaleArngCode === 'MCHT_DLVR';
            };
        },
        crdtPntDisabled() {
            return product =>
                (product.crdtPntEnblInd ||
                    this.$store.state.saleCatgUseTcoinMap?.[
                        product.saleCatgSlctCode
                    ]) !== 'Y';
        },
        prmtEvntDisabled() {
            return product =>
                (product.prmtEvntEnblInd ||
                    this.$store.state.luckydraw2021IndMap?.[
                        product.saleCatgSlctCode
                    ]) !== 'Y';
        },
        hasActivePrmtEvnt() {
            return this.$store.getters.hasActivePrmtEvnt;
        }
    }
};
</script>
